/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualProductDto } from '../../models/backend-actual-product-dto';
import { BackendActualProductRequestDto } from '../../models/backend-actual-product-request-dto';

export interface MonitoringActualsProductsUpdate$Params {
  id: number;
  body: BackendActualProductRequestDto;
}

export function monitoringActualsProductsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsProductsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualProductDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsProductsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualProductDto>;
    }),
  );
}

monitoringActualsProductsUpdate.PATH = '/api/monitoring/actuals/products/{id}/';
